import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DashboardService } from '../dashboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


export interface DialogData {
  visitid: number; 
  remark: string;
  //name: string;
}

@Component({
  selector: 'app-changeremark',
  templateUrl: './changeremark.component.html',
  styleUrls: ['./changeremark.component.scss'] 
})
export class ChangeremarkComponent implements OnInit {
  destroychangerem$: Subject<boolean> = new Subject<boolean>();
  private changedremark:any;

  constructor(
    private dashboardService:DashboardService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private dialogRef: MatDialogRef<ChangeremarkComponent>,
  ) { 
    this.changedremark = this.data.remark;
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.destroychangerem$.next(true);
    this.destroychangerem$.unsubscribe();
    this.changedremark =null;
  }
  closedialog(){
  this.dialogRef.close();
  }
  updateremark(){
   // var res = str.substring(0, 7);
   const leftstring = this.changedremark.substring(0, 69);
    this.dashboardService.open_loader_Dialog();
   this.dashboardService.updateremark(this.data.visitid, leftstring).pipe(takeUntil(this.destroychangerem$)).subscribe(
     data => this.successremark(data), err => this.failedremark(err)
   )
  } 

  successremark(data){
  this.dashboardService.remarkupdated = true;
  this.dialog.closeAll();
  this.dashboardService.openSnackBar("remark updated successfully", "OK");
 
  }

  failedremark(err){
    this.dashboardService.remarkupdated = false;
    this.dialog.closeAll();
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  
}
